import { render, staticRenderFns } from "./IconEmail2.vue?vue&type=template&id=aeb0d554&scoped=true&"
import script from "./IconEmail2.vue?vue&type=script&lang=js&"
export * from "./IconEmail2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb0d554",
  null
  
)

export default component.exports